// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-QSb","icon":"styles_icon__1SZGI"};